import React from 'react';
import PropTypes from 'prop-types';

import * as Header from 'components/Header';
import Remote from '../remote';

const ToolsetLayout = ({ match, history }) => (
  <div className="page-container">
    <Header.Toolset />
    <Remote match={match} history={history} />
  </div>
);

ToolsetLayout.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default ToolsetLayout;
